<!-- Wrapper div to ensure the autocomplete dropdown is aligned with the search input and button -->
<div class="d-flex flex-column flex-grow-1 position-relative">

    <form novalidate [formGroup]="form">

        <div class="input-group">

            <sq-scope [query]="searchService.query" *ngIf="appService.ccquery?.scopesActive"></sq-scope>

            <!-- Input with autocomplete -->
            <div class="form-control d-flex pe-1" [title]="parseResult?.error || ''"
                [ngClass]="{'is-invalid': !!parseResult?.error}">

                <!-- scroll left -->
                <button type="button" class="btn btn-focus p-0" *ngIf="hasScroll"
                    [sqTooltip]="'msg#searchForm.scrollLeft' | sqMessage" [disabled]="!loginService.complete"
                    (mouseup)="endScroll()" (mousedown)="scrollLeft()">
                    <i class="fas fa-chevron-circle-left text-muted"></i>
                </button>

                <div class="d-flex search-form-control scrollbar-hidden" #searchContainer>

                    <!-- Fielded search -->
                    <sq-field-search-items #fieldSearchItemsContainer></sq-field-search-items>

                    <!-- Search input -->
                    <input type="text" class="search-input flex-grow-1" formControlName="search" spellcheck="false"
                        autocomplete="off" [placeholder]="'msg#searchForm.searchFor' | sqMessage"
                        [sqAutofocus]="autofocus" [sqAutocompleteExtended]="autocompleteSources" [dropdown]="dropdown"
                        [off]="!loginService.complete || !appService.suggestQueries"
                        [suggestQuery]="appService.suggestQueries? appService.suggestQueries[0] : ''"
                        [fieldSearchMode]="getMode()" [fieldSearchExpression]="fieldSearchExpression"
                        [fieldSearchItemsContainer]="fieldSearchItemsContainer"
                        [excludedFields]="['concepts','textlexicon','recent-query','saved-query','basket','recent-document']"
                        (submit)="search()" (parse)="onParse($event)" (mousedown)="onMouseDown()" #searchInput>

                </div>

                <!-- scroll right -->
                <button type="button" class="btn btn-focus p-0 me-2" *ngIf="hasScroll"
                    [sqTooltip]="'msg#searchForm.scrollRight' | sqMessage" [disabled]="!loginService.complete"
                    (mouseup)="endScroll()" (mousedown)="scrollRight()">
                    <i class="fas fa-chevron-circle-right text-muted"></i>
                </button>

                <!-- Clear Button -->
                <button type="button" *ngIf="hasContent() && !hideSearch" class="btn btn-focus p-0 me-2"
                    [sqTooltip]="'msg#searchForm.clear' | sqMessage" [disabled]="!loginService.complete"
                    (click)="clearForm()">
                    <i class="fas fa-times-circle text-muted"></i>
                </button>
                <button type="button" class="edit-btn  btn-focus" >
                <i class="fas fa-pencil-alt edit-btn-i"></i>
            </button>

                <button type="button" *ngIf="hasContent() && hideSearch" class="btn clear-btn p-0 me-2"
                    [sqTooltip]="'msg#searchForm.clear' | sqMessage" [disabled]="!loginService.complete"
                    (click)="clearForm()">
                    <i class="fas fa-times text-muted"></i>
                </button>

                <!-- Keep Filters Button -->
                <button type="button" *ngIf="isFiltering && enableKeepFilters" class="btn btn-focus p-0 me-2"
                    [sqTooltip]="keepFiltersTitle | sqMessage" [disabled]="!loginService.complete"
                    (click)="toggleKeepFilters()">
                    <i class="fas fa-filter" [ngClass]="keepFilters ? 'light-green' : 'text-muted'"></i>
                </button>

                <!-- Keep Filters Button -->
                <button type="button" *ngIf="appService.isNeural()" class="btn btn-focus p-0 me-2"
                    [sqTooltip]="neuralSearch? 'Neural Search is activated' : 'Neural Search is off'"
                    [disabled]="!loginService.complete" (click)="toggleNeuralSearch()">
                    <i class="fas fa-brain" [ngClass]="neuralSearch ? 'light-green' : 'text-muted'"></i>
                </button>

                <!-- Toggle voice recognition -->
                <button *ngIf="voiceService.available && enableVoiceRecognition" type="button"
                    class="btn btn-focus p-0 me-2" [sqTooltip]="'msg#searchForm.voiceRecognition' | sqMessage"
                    (click)="toggleVoice()">
                    <i class="fas fa-microphone" [ngClass]="voiceRecognitionState ? 'light-green' : 'text-muted'"></i>
                </button>

                <!-- Toggle advanced search -->
                <button type="button" *ngIf="enableAdvancedForm && !hideSearch" class="btn p-0 pe-1"
                    [ngClass]="{'me-4': !!parseResult?.error}" [sqTooltip]="'msg#searchForm.advancedSearch' | sqMessage"
                    [disabled]="!loginService.complete" (click)="toggleAdvancedSearch()">
                    <i class="fas fa-chevron-circle-{{showAdvancedSearch ? 'up' : 'down'}}" [ngClass]="{'text-muted': !hasAdvancedContent() && !isAdvancedSearchActive(),
                                    'light-green': isAdvancedSearchActive(),
                                    'light-blue': hasAdvancedContent() && !isAdvancedSearchActive()}">
                    </i>
                </button>
                <button class="search-btn" type="button" (click)="search()" *ngIf="hideSearch"
                    [sqTooltip]="'msg#searchForm.search' | sqMessage"
                    [disabled]="!loginService.complete || !form.valid">
                    <i class="fas fa-search"></i>
                </button>
            </div>

            <!-- Search buttons -->
            <button class="btn btn-primary" type="button" (click)="search()" *ngIf="!hideSearch"
                [sqTooltip]="'msg#searchForm.search' | sqMessage" [disabled]="!loginService.complete || !form.valid">
                <i class="fas fa-search"></i>
            </button>
        </div>

        <!-- Card displaying advanced-search -->
        <div class="card advanced-search" *ngIf="showAdvancedSearch">
            <div class="card-header ps-3 pe-2 py-1">
                <div class="d-flex justify-content-between">
                    <span class=" mb-0 py-1">
                        <i class="fab fa-searchengin me-2"></i>
                        {{'msg#searchForm.advancedSearch' | sqMessage}}
                    </span>
                    <button type="button" class="btn btn-light btn-sm" *ngIf="isAdvancedSearchActive()"
                        [sqTooltip]="'msg#facet.clearSelects' | sqMessage" (click)="clearAdvancedSearch()">
                        <i class="far fa-minus-square"></i>
                    </button>
                </div>
            </div>
            <div *ngIf="!firstPageService.firstPage" class="d-flex flex-column align-items-stretch ps-3 pe-2 py-1">
                <span class="fas fa-sync fa-spin fa-fw"></span>
            </div>
            <div *ngIf="firstPageService.firstPage" class="d-flex flex-column align-items-stretch ps-3 pe-2 py-1">
                <sq-advanced-form-select [form]="form" [field]="'treepath'" [multiple]="true"></sq-advanced-form-select>
                <sq-advanced-form-select [form]="form" [field]="'authors'" [multiple]="true"></sq-advanced-form-select>
                <sq-advanced-form-range [form]="form" [field]="'size'"></sq-advanced-form-range>
                <sq-advanced-form-range [form]="form" [field]="'modified'"></sq-advanced-form-range>
                <sq-advanced-form-multi-input [form]="form" [field]="'person'"
                    [suggestQuery]="appService.suggestQueries? appService.suggestQueries[0] : ''"></sq-advanced-form-multi-input>
                <sq-advanced-form-input [form]="form" [field]="'docformat'"
                    [suggestQuery]="appService.suggestQueries? appService.suggestQueries[0] : ''"></sq-advanced-form-input>
            </div>
        </div>
    </form>

    <!-- Autocomplete dropdown panel displaying suggestions -->
    <sq-autocomplete-list #dropdown>
        <ng-template #itemTpl let-item>
            <div class="autocomplete-item p-2">
                <i class="{{autocompleteIcon(item.category)}}"></i><!--
                --><span class="mx-2" [innerHTML]="item.displayHtml || item.display"></span><!--
                --><small *ngIf="item.category" class="autocomplete-category ms-2">{{(item.label || item.category) |
                    sqMessage}}</small>
            </div>
        </ng-template>

        <ng-template #footerTpl *ngIf="!hideSearch">
            <div class="small d-flex align-items-center">
                {{ 'msg#searchForm.fieldedSearch' | sqMessage}}: &nbsp;
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="off" value="off" (click)="setMode('off')"
                        [checked]="getMode() === 'off'">
                    <label class="form-check-label" for="off" (click)="setMode('off', $event)">{{ 'msg#searchForm.off' |
                        sqMessage}}</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="selects" value="selects"
                        (click)="setMode('selects')" [checked]="getMode() === 'selects'">
                    <label class="form-check-label" for="selects" (click)="setMode('selects', $event)"
                        [title]="'msg#searchForm.simpleTitle' | sqMessage">{{ 'msg#searchForm.simple' |
                        sqMessage}}</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="text" value="text" (click)="setMode('text')"
                        [checked]="getMode() === 'text'">
                    <label class="form-check-label" for="text" (click)="setMode('text', $event)"
                        [title]="'msg#searchForm.advancedTitle' | sqMessage">{{ 'msg#searchForm.advanced' |
                        sqMessage}}</label>
                </div>
            </div>
        </ng-template>
    </sq-autocomplete-list>
    <sq-loading-bar></sq-loading-bar>

</div>